import React from 'react';
import { Box, Grow, Popper, Typography } from '@material-ui/core';
import { GrowProps } from '@material-ui/core';
import classnames from 'classnames';
import { useHistory } from 'react-router';
import { SGSButton } from 'components';
import styles from './SGSHelpButton.module.scss';
import ChatHead from 'assets/Emma_005.svg';
import { hasRole } from 'core/utils/roles';
import { useAppContext } from 'core/contexts';
import { Link } from 'react-router-dom';
import idee from '../../assets/idee.svg';

type Props = {};

const SGSHelpButton: React.FC<Props> = () => {
    const history = useHistory();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;
    const { user } = useAppContext();

    const popperTrans = ({ TransitionProps }: { TransitionProps: GrowProps }) => (
        <Grow {...TransitionProps} timeout={500} style={{ transformOrigin: 'bottom right' }}>
            <Box className={styles.content}>
                <Box className={styles.close} onClick={handleClick}>
                    <i className="fas fa-times"></i>
                </Box>
                <Box className={styles.content__title}>Votre espace fait peau neuve !</Box>
                <Box className="pl-3 pr-3 pb-4">
                    <Box className={styles.content__text}>
                        <Typography>Plus ergonomique, moderne et complet, nous espérons que les fonctionnalités sauront vous apporter satisfaction !</Typography>
                    </Box>
                    <Box className={styles.content__text}>
                        <Typography>Un peu perdu dans ce nouvel univers ?</Typography>
                        <Typography>Nous avons pensé à vous ! Retrouvez une courte vidéo de présentation de votre espace.</Typography>
                    </Box>
                    <Box className={styles.content__text}>
                        <Typography> Votre question est plus spécifique ?</Typography>
                        <Typography>Contactez nos équipes pour obtenir une assistance dédiée !</Typography>
                    </Box>
                </Box>
                <Box display="flex" justifyContent="center" gridGap="10px">
                    {hasRole(user, ['ROLE_POUET']) && <SGSButton onClick={() => history.push('/contact')}>Nous contacter</SGSButton>}
                    <SGSButton onClick={() => window.open('https://youtu.be/ug750jrpys0')}>Tutoriel Vidéo</SGSButton>
                </Box>
                <Box className="mt-3 text-center">
                    <img src={idee} width={'30'} height={'30'} className={'mr-1'} alt="" />{' '}
                    <Link to={'/boite_a_idees'} style={{ color: '#3399db ' }}>
                        <span style={{ textDecoration: 'underline' }}>Aidez-nous à améliorer notre site !</span>
                    </Link>
                </Box>
            </Box>
        </Grow>
    );

    return (
        <>
            <Box className={classnames(styles.container, open && styles.container__open)}>
                <Box onClick={handleClick} justifyContent="space-between">
                    <Box display="flex" flexDirection="column" gridGap="20px" alignItems="center" maxHeight="200px">
                        <img src={ChatHead} alt="chat head" className={styles.help__head} />
                    </Box>
                </Box>
            </Box>
            <Popper id={id} open={open} anchorEl={anchorEl} transition placement="top-start" className={styles.popper}>
                {popperTrans}
            </Popper>
        </>
    );
};

export default SGSHelpButton;
